import militaryStatus from './military-status';
import releaseDate from './release-date';
import fileBdd from './file-bdd';
import unableToFileBdd from './unable-to-file-bdd';
import claimType from './claim-type';
import pactEligibility from './pact-eligibility';
import evidenceNeeded from './evidence-needed';

/**
 * The subtask flow branches (military status splits into a standard and an
 * active-duty BDD path) and re-converges on evidence-needed. That flow is
 * documented and enforced end-to-end in
 * `tests/all-claims-screener-flow.cypress.spec.js`
 */
export default [
  militaryStatus,
  releaseDate,
  fileBdd,
  unableToFileBdd,
  claimType,
  pactEligibility,
  evidenceNeeded,
];
